// Unified Job File pipeline: one set of stages from prospect to completion.
export const STAGES = [
  { key: "new", label: "New quote", cls: "bg-[#F0EAE0] text-[#6B7280]" },
  { key: "contacted", label: "Contacted", cls: "bg-[#DCE9F5] text-[#12263A]" },
  { key: "site_visit", label: "Site visit", cls: "bg-[#EADBF3] text-[#5B2A83]" },
  { key: "booking", label: "Booking", cls: "bg-[#FBE3D6] text-[#8A3D0A]" },
  { key: "survey", label: "Survey", cls: "bg-[#EADBF3] text-[#5B2A83]" },
  { key: "confirmed", label: "Confirmed", cls: "bg-[#D8EED8] text-[#1F6B3B]" },
  { key: "drawings", label: "Drawings", cls: "bg-[#DCE9F5] text-[#12263A]" },
  { key: "build", label: "Build", cls: "bg-[#12263A] text-white" },
  { key: "complete", label: "Complete", cls: "bg-[#1F6B3B] text-white" },
];

const LEGACY = {
  site_talk_booked: "site_visit", site_talk_done: "site_visit",
  deposit_paid: "booking", survey_booked: "survey", survey_done: "survey",
  job_confirmed: "confirmed",
};

export const normStage = (s) => {
  const k = LEGACY[s] || s;
  return STAGES.some(x => x.key === k) ? k : "new";
};

export const stageIndex = (s) => STAGES.findIndex(x => x.key === normStage(s));

export function StagePill({ stage }) {
  const key = normStage(stage);
  const def = STAGES.find(s => s.key === key) || STAGES[0];
  return (
    <span data-testid={`stage-pill-${key}`}
      className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-widest ${def.cls}`}>
      {def.label}
    </span>
  );
}
